/* eslint-disable-rule react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from 'react'
import useData from '../hooks/useData'
import useInputValue from '../hooks/useInputValue'
import Input from './Input'
import Button from './Button'
import Loading from './Loading'
import Icon from './Icon'
import URL from './URL'
import { debounce } from '../modules/helpers'
import { INPUT_DEBOUNCE_TIME } from '../constants/'
import { ResourcesContext } from './ArticleResourcesContent'

const triggerSuggest = debounce((Fn, value) => Fn(value), INPUT_DEBOUNCE_TIME)

const ArticleResources = (props) => {
    const resourcesContext = useContext(ResourcesContext)
    // const article_id = resourcesContext.article_id || props.article_id || (props.match && props.match.params && props.match.params.article_id) || false
    const [query, setQuery] = useState('')
    const [suggestFromQuery, setSuggestFromQuery] = useState('')
    const [suggestIsExpanded, setSuggestIsExpanded] = useState(false)
    const [pageIndex, setPageIndex] = useState(0)
    const googleLocale = 'fr_FR'
    const queryField = useInputValue('')
    const GoogleSearch = useData(
        {
            url: 'google/search?locale=' + googleLocale + '&query=' + query,
        },
        [query && query.length]
    )
    const CrawledPage = useData(
        {
            url: 'competitor/crawl_page?url64=' + (GoogleSearch.data && btoa(GoogleSearch.data.items[pageIndex].link)),
        },
        [GoogleSearch.isReady]
    )
    const CrawledPageDetails = useData(
        {
            url: 'competitor/extract_from_page?url64=' + (GoogleSearch.data && btoa(GoogleSearch.data.items[pageIndex].link)),
        },
        [GoogleSearch.isReady]
    )
    const suggestions = useData('google/suggest?locale=' + googleLocale + '&query=' + suggestFromQuery, [suggestFromQuery.length > 3])

    const changePageIndex = (pageIndex) => {
        setPageIndex(pageIndex)
        resourcesContext.setUrl && GoogleSearch.isReady && GoogleSearch.data.items && resourcesContext.setUrl(GoogleSearch.data.items[pageIndex].link)
        resourcesContext.setDisplayUrl &&
            GoogleSearch.isReady &&
            GoogleSearch.data.items &&
            resourcesContext.setDisplayUrl(GoogleSearch.data.items[pageIndex].displayLink)
    }
    useEffect(() => changePageIndex(pageIndex), [GoogleSearch.isReady])

    const { origin } = props

    useEffect(() => {
        console.log('adding ui to', resourcesContext)
        CrawledPage.isReady &&
            resourcesContext.addUIToText({
                origin,
                target_article: resourcesContext.article_id,
                displayUrl: GoogleSearch.isReady && GoogleSearch.data.items[pageIndex].displayLink,
                originalUrl: GoogleSearch.isReady && GoogleSearch.data.items[pageIndex].link,
            })
    }, [CrawledPage.isReady, resourcesContext.article_id])

    useEffect(() => {
        window.addEventListener('click', hideSuggestions)
        return () => {
            window.removeEventListener('click', hideSuggestions)
        }
    }, [])
    const hideSuggestions = (e) => e.target.id !== 'query-field' && setSuggestIsExpanded(false)

    const handleSearchInputKeyPress = (e) => {
        queryField.onChange(e)
        !suggestIsExpanded && setSuggestIsExpanded(true)
        triggerSuggest(setSuggestFromQuery, e.target.value)
    }
    // console.log({ articleData })
    return (
        <>
            {(
                <>
                    <div className="row">
                        <div className="col-xxl-12">
                            {/* <small>{siteData.data.label}</small>
                            <h2>{articleData.data.title}</h2> */}
                            <form
                                style={{ position: 'relative' }}
                                onSubmit={(e) => e.preventDefault() || setQuery(queryField.value) || changePageIndex(0) || setSuggestIsExpanded(false)}
                            >
                                <div className="input-group mb-3">
                                    <Input
                                        type="text"
                                        {...queryField}
                                        id="query-field"
                                        onChange={handleSearchInputKeyPress}
                                        onFocus={() => setSuggestIsExpanded(true)}
                                    />
                                    <div className="input-group-append">
                                        <Button
                                            {...GoogleSearch}
                                            className="btn-google"
                                            onClick={() => setQuery(queryField.value) || changePageIndex(0) || setSuggestIsExpanded(false)}
                                        >
                                            <Icon name="google" /> SEARCH
                                        </Button>
                                    </div>
                                </div>
                                {(GoogleSearch.isReady && (
                                    <>
                                        <div className="progress" style={{ height: '1px' }}>
                                            <div
                                                className={
                                                    'progress-bar' +
                                                    (((GoogleSearch.data.daily_count / (GoogleSearch.data.daily_max || 100)) * 100 >= 90 && ' bg-danger') || '')
                                                }
                                                role="progressbar"
                                                style={{ width: (GoogleSearch.data.daily_count / (GoogleSearch.data.daily_max || 100)) * 100 + '%' }}
                                                aria-valuenow={(GoogleSearch.data.daily_count / (GoogleSearch.data.daily_max || 100)) * 100}
                                                aria-valuemin="0"
                                                aria-valuemax={GoogleSearch.data.daily_max || 100}
                                            />
                                        </div>
                                    </>
                                )) ||
                                    null}
                                {(suggestIsExpanded && suggestions.isReady && suggestions.data && suggestions.data.result && suggestions.data.result[1] && (
                                    <ul className="list-unstyled suggest border-left border-bottom border-right w-100">
                                        {suggestions.data.result[1].map((s, index) => (
                                            <li
                                                key={`suggestion-${index}`}
                                                className={'pointer'}
                                                onClick={(e) => queryField.onChange({ target: { value: s } }) || setQuery(s)}
                                            >
                                                {s}
                                            </li>
                                        ))}
                                    </ul>
                                )) ||
                                    null}
                            </form>
                            {(GoogleSearch.isReady && GoogleSearch.data && GoogleSearch.data.items && (
                                <>
                                    <div id="block-toolbar-container" className="pb-3">
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <Button
                                                    onClick={() => pageIndex > 0 && changePageIndex(pageIndex - 1)}
                                                    className={'btn-secondary' + ((pageIndex === 0 && ' disabled') || '')}
                                                    disabled={pageIndex === 0}
                                                >
                                                    &laquo;
                                                </Button>
                                            </div>
                                            <Input
                                                type="native-select"
                                                options={GoogleSearch.data.items.map((i, index) => ({
                                                    label: parseInt(index) + 1 + ' - ' + i.title + ' - ' + i.displayLink,
                                                    value: index,
                                                }))}
                                                onChange={changePageIndex}
                                                value={pageIndex}
                                            />
                                            <div className="input-group-append">
                                                <Button
                                                    onClick={() =>
                                                        console.log(pageIndex, GoogleSearch.data.items.length - 1, parseInt(pageIndex) + 1) ||
                                                        (pageIndex < GoogleSearch.data.items.length - 1 && changePageIndex(parseInt(pageIndex) + 1))
                                                    }
                                                    className={'btn-secondary' + ((pageIndex >= GoogleSearch.data.items.length - 1 && ' disabled') || '')}
                                                    disabled={pageIndex >= GoogleSearch.data.items.length - 1}
                                                >
                                                    &raquo;
                                                </Button>
                                            </div>
                                        </div>
                                        {(CrawledPage.isReady && (
                                            <>
                                                <strong className="d-block mt-2">
                                                    {GoogleSearch.data.items[pageIndex].title}
                                                    {CrawledPage.data.provider && (
                                                        <span className="badge badge-amazon ml-1">
                                                            <Icon className="mr-1" name={CrawledPage.data.provider} />
                                                            Amazon
                                                        </span>
                                                    )}
                                                </strong>
                                                <small>
                                                    <URL url={GoogleSearch.data.items[pageIndex].link} link={true} />
                                                </small>
                                                <small>
                                                    <ul className="list-unstyled">
                                                        <li>
                                                            {(CrawledPageDetails.isReady && (
                                                                <>
                                                                    {CrawledPageDetails.isReady &&
                                                                        CrawledPageDetails.data.affiliate_links &&
                                                                        CrawledPageDetails.data.affiliate_links.length}{' '}
                                                                    affiliate link
                                                                    {(CrawledPageDetails.isReady &&
                                                                        CrawledPageDetails.data.affiliate_links &&
                                                                        CrawledPageDetails.data.affiliate_links != 1 &&
                                                                        's') ||
                                                                        null}
                                                                </>
                                                            )) || <span className="text-muted">Loading affiliate links...</span>}
                                                        </li>
                                                        <li>
                                                            {(CrawledPageDetails.isReady && (
                                                                <>
                                                                    {CrawledPageDetails.isReady &&
                                                                        CrawledPageDetails.data.internal_links &&
                                                                        CrawledPageDetails.data.internal_links.length}{' '}
                                                                    internal link
                                                                    {(CrawledPageDetails.isReady &&
                                                                        CrawledPageDetails.data.affiliate_links &&
                                                                        CrawledPageDetails.data.internal_links != 1 &&
                                                                        's') ||
                                                                        null}
                                                                </>
                                                            )) || <span className="text-muted">Loading internal links...</span>}
                                                        </li>
                                                        <li>
                                                            {(CrawledPageDetails.isReady && (
                                                                <>
                                                                    {CrawledPageDetails.isReady &&
                                                                        CrawledPageDetails.data.external_links &&
                                                                        CrawledPageDetails.data.external_links.length}{' '}
                                                                    external link
                                                                    {(CrawledPageDetails.isReady &&
                                                                        CrawledPageDetails.data.affiliate_links &&
                                                                        CrawledPageDetails.data.external_links != 1 &&
                                                                        's') ||
                                                                        null}
                                                                </>
                                                            )) || <span className="text-muted">Loading external links...</span>}
                                                        </li>
                                                    </ul>
                                                </small>
                                                <hr />
                                            </>
                                        )) ||
                                            (CrawledPage.isLoading && <Loading text="Crawling page" />) ||
                                            null}
                                    </div>
                                </>
                            )) ||
                                null}
                            {(CrawledPage.isReady && (
                                <>
                                    <div className="competitor-page-html" dangerouslySetInnerHTML={{ __html: CrawledPage.data.body }} />
                                </>
                            )) ||
                                null}
                        </div>
                    </div>
                </>
            ) || <Loading text="Fetching article and site data" />}
        </>
    )
}

export default ArticleResources
